export const PUBLIC_APP_ROOT = 'PublicAppRoot';
export const RECOMMENDED_PAGE = 'RecommendedPage';
export const SMART_CRM_PAGE = 'SmartCrmPage';
export const SMART_CRM_PAGE_CONTENT = 'SmartCrmPageContent';
export const MARKETING_PLUS_PAGE = 'MarketingPlusPage';
export const MARKETING_PLUS_PAGE_CONTENT = 'MarketingPlusPageContent';
export const BUNDLE_PAGE = 'BundlePage';
export const SUITE_PAGE = 'SuitePage';
export const SUITE_PAGE_CONTENT = 'SuitePageContent';
export const PRODUCT_PAGE = 'ProductPage';
export const PRODUCT_PAGE_CONTENT = 'ProductPageContent';
export const ADD_ONS_PAGE = 'AddOnsPage';
export const ADD_ONS_PAGE_CONTENT = 'AddOnsPageContent';
export const COMMERCE_PAGE = 'CommercePage';
export const COMMERCE_HUB_PAGE_CONTENT = 'CommerceHubPageContent';
export const FREE_TOOLS_PAGE = 'FreeToolsPage';
export const FREE_TOOLS_PAGE_CONTENT = 'FreeToolsPageContent';
export const MISSING_INFO_FALLBACK_PAGE = 'MissingInfoFallbackPage';
export const MARKETING_HUB_PAGE = 'MarketingHubPage';
export const MARKETING_HUB_PAGE_CONTENT = 'MarketingHubPageContent';
export const SALES_HUB_PAGE = 'SalesHubPage';
export const SALES_HUB_PAGE_CONTENT = 'SalesHubPageContent';
export const SERVICE_HUB_PAGE = 'ServiceHubPage';
export const SERVICE_HUB_PAGE_CONTENT = 'ServiceHubPageContent';
export const CUSTOMER_PLATFORM_PAGE = 'CustomerPlatformPage';
export const CUSTOMER_PLATFORM_PAGE_CONTENT = 'CustomerPlatformPageContent';
export const CONTENT_HUB_PAGE = 'ContentHubPage';
export const CONTENT_HUB_PAGE_CONTENT = 'ContentHubPageContent';
export const DATA_HUB_PAGE = 'DataHubPage';
export const DATA_HUB_PAGE_CONTENT = 'DataHubPageContent';
export const CONFIG_DRIVEN_PAGE = 'ConfigDrivenPage';
export const CONFIG_DRIVEN_PAGE_CONTENT = 'ConfigDrivenPageContent';
export const HUBSPOT_ON_CREDITS_PAGE = 'HubSpotOnCreditsPage';
export const PHONE_SUPPORT = 'PhoneSupport';